import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ spacing }) => ({
  tags: {
    '& > *': {
      marginLeft: spacing(1),
    },
  },
}));
